import { useCallback, useMemo } from "react";
import Graph_QL, { DynamicDataObk, StateDataObject } from "..";
import { useApolloClient } from "@apollo/client";
import { CREATE_WIDGET, CreateWidgetResponse, DELETE_WIDGET, DeleteWidgetResponse, UPDATE_WIDGET, UpdateWidgetResponse, Widget, WIDGET_CALLS, WidgetResponse } from "./GQLCalls/wigdetCalls";
import { useAppDispatch, useAppSelector } from "../../../Store";
import { gqlActions } from "../gqlData_Reducer";
import { WidgetItem } from "./WidgetSlices/widgetSlice";
import { BasicQueryInfoInput } from "../FeedDataCalls/GQLCalls/getFeedComponentsCall";
import { filterByConnection } from "../filterByConnection";

// interface WidgetHelperFunctions {
  // createWidget: (newWidget: CreateWidgetResponse[]) => void;
  // deleteWidget: (deletedWidget: DeleteWidgetResponse[]) => void;
//  }

// const getWidgetState = (state: RootState) => {return state.graphQlData.domain.widgetCall} 

export const useWidget = (connection: Graph_QL.GQLCons) => {
  const dispatch = useAppDispatch();
  const client = useApolloClient();

  const widgetState = useAppSelector(({graphQlData:{domain}}) => domain.widgetCall);
  const {fullState} = useMemo(() => {
    const state = filterByConnection(widgetState, Graph_QL.ToArr(connection)) as Record<string, WidgetItem>
    return Object.entries(state).reduce((accumulator, [key, data]) => {
      if (data.data) {
        const value = {...data.data, domain:key}; 
        accumulator.data = accumulator.data.concat(value)
      }
      return accumulator
    },{fullState: state, data: []} as StateDataObject<WidgetItem>)
  },[connection, widgetState]);

  // #region | Get Widget Info
  const getWidgetInfo = useCallback(async (input: BasicQueryInfoInput, specific?: Graph_QL.GQLCons) => {
    const specificConnection = specific ? specific : connection;
    try {
      client.query<WidgetResponse>({ query: WIDGET_CALLS, variables: { ...specificConnection.connection, input: { ids: input?.ids, offset: input?.offset, fetchAmount: input?.fetchAmount }}, fetchPolicy: "no-cache" })
        .then((e) => {
          if (e && e.data) {
            dispatch({type: String(gqlActions.domain.widgets.update), payload: {con: specificConnection.connection, data: e.data.widget.info}});
          }
        }).catch((error) => {console.log(error)})
    } catch (error) {
        console.log(error);
      }
  }, [client, connection, dispatch])
  // #endregion
  
  // #region | Maintain Widget Entries
  const maintainEntries = async (widgetData?: Partial<DynamicDataObk<Widget[]>>) => {
    try {
      if (widgetData && widgetData.data) {
        client.mutate<UpdateWidgetResponse>({mutation: UPDATE_WIDGET, variables: {...connection.connection, input: widgetData.data}})
        .then((response) => {
          if (response && response.data ) {
            dispatch({ type: String(gqlActions.domain.widgets.update), payload: { con: connection.connection, data: response.data.widget.update.updatedValues } });
          }
        })
      }
    } catch (error) {
      console.log(error);
    }
  }
  // #endregion

  // #region | Create Widget
  const createWidget = async (widgetData?: Partial<DynamicDataObk<Omit<Widget, "widget_id">>>) => {
    const updatedWidget = widgetData?.data;
    let newWidget = updatedWidget;
    if (newWidget && "__typename" in newWidget) {
      const { __typename, ...remaining } = newWidget;
      newWidget = remaining;
    }
    try {
      if (newWidget) {
        client.mutate<CreateWidgetResponse>({mutation: CREATE_WIDGET, variables: {...connection.connection, input: [newWidget]}})
        .then((response) => {
          if (response && response.data ) {
            dispatch({ type: String(gqlActions.domain.widgets.update), payload: { con: connection.connection, data: response.data.widget.create.updatedValues } });
          }
        })
      }
    } catch (error) {
      console.log(error);
    }
  }
  // #endregion

  // #region | Delete Widget
  const deleteWidget = useCallback(async (widgetData?: Partial<DynamicDataObk<Widget[]>>) => {
    const toDelete = widgetData?.data?.map((widget) => widget.widget_id) ?? [];
    try {
      if (toDelete)
      client.mutate<DeleteWidgetResponse>({mutation: DELETE_WIDGET, variables: {...connection.connection, widgetIds: toDelete}})
        .then((response) => {
          if (response.data?.widget.delete.success) {
            dispatch({
              type: String(gqlActions.domain.widgets.deleted), payload: { con: connection.connection, data: toDelete }
            });
          } else {
            console.warn("Delete failed:", response.data?.widget.delete.message);
          }
        }).catch((error) => {console.log(error)})
    } catch (error) {
      console.log(error);
    }
  }, [client, connection.connection, dispatch])
  // #endregion

    return {call: getWidgetInfo, data: fullState, maintainEntries, createWidget, deleteWidget };
}

